import { render } from "./CreateAutoScaleVmGroup.vue?vue&type=template&id=3b6e395f&scoped=true"
import script from "./CreateAutoScaleVmGroup.vue?vue&type=script&lang=js"
export * from "./CreateAutoScaleVmGroup.vue?vue&type=script&lang=js"

import "./CreateAutoScaleVmGroup.vue?vue&type=style&index=0&id=3b6e395f&lang=less&scoped=true"
import "./CreateAutoScaleVmGroup.vue?vue&type=style&index=1&id=3b6e395f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6e395f"]])

export default __exports__